function horizontalImageSlider(id, e) {
	if (e.type === "DOMContentLoaded" || e.type === "resize") {
		localStorage.setItem("slideIndex_" + id, 0);
		scrollSpeed = 1200;
		imageContainerId = "#" + id;
		imageGalleryScrollContainer = $(imageContainerId).find('.horizontal-scroll');
		imageGalleryScrollContainer[0].scrollLeft = 0;
		tempitemfirstChild = $(imageContainerId).find('.horizontal-scroll .item:first-child');
		itemDiv = $(imageGalleryScrollContainer).find('.item')[0];
		horizontalScrollDivWidth = imageGalleryScrollContainer[0].offsetWidth;
		itemWidthValue = parseInt(window.getComputedStyle(itemDiv).width) + parseInt(window.getComputedStyle(itemDiv).marginLeft) + parseInt(window.getComputedStyle(itemDiv).marginRight);
		itemsperScroll = parseInt(horizontalScrollDivWidth / itemWidthValue);
		var spaceBetweenItems = 5.5;
		scrollWidth = ((itemWidthValue + spaceBetweenItems) * itemsperScroll);//window width per slide
		var tempId = imageGalleryScrollContainer;
		$(tempId).css('max-width', scrollWidth);
		localStorage.setItem("scrollWidth_" + id, scrollWidth);
		noOfItems = $(imageGalleryScrollContainer[0]).find('.item').length;
		slideNumber = parseInt(noOfItems / itemsperScroll);//number of slide on click of arrow button
		localStorage.setItem("slideNumber_" + id, slideNumber);
		previousArrow(id, localStorage.getItem("slideIndex_" + id));
		nextArrow(id, localStorage.getItem("slideIndex_" + id));
	}
	if (e.type === "click") {
		if ($(e.currentTarget).hasClass('horizontal-arrow-right')) {
			rightScroll(id);
		}
		if ($(e.currentTarget).hasClass('horizontal-arrow-left')) {
			leftScroll(id);
		}
	}
	function rightScroll(scrollContainerId) {
		scrollContainerIdDiv = "#" + scrollContainerId;
		var scrollContainerSlideIndex = parseInt(localStorage.getItem("slideIndex_" + scrollContainerId));
		var scrollContainerSlideNumber = parseInt(localStorage.getItem("slideNumber_" + scrollContainerId));
		var scrollContainerWidth = parseInt(localStorage.getItem("scrollWidth_" + scrollContainerId));
		if (scrollContainerSlideIndex < scrollContainerSlideNumber) {
			scrollContainerSlideIndex++;
			$(scrollContainerIdDiv).find('.horizontal-scroll').animate({
				scrollLeft: '+=' + scrollContainerWidth
			}, scrollSpeed);
		}
		nextArrow(scrollContainerId, scrollContainerSlideIndex);
		previousArrow(scrollContainerId, scrollContainerSlideIndex);
		localStorage.setItem("slideIndex_" + scrollContainerId, scrollContainerSlideIndex);
	}
	function leftScroll(scrollContainerId) {
		scrollContainerIdDiv = "#" + scrollContainerId;
		var scrollContainerSlideIndex = localStorage.getItem("slideIndex_" + scrollContainerId);
		var scrollContainerWidth = localStorage.getItem("scrollWidth_" + scrollContainerId);
		if (scrollContainerSlideIndex > 0) {
			scrollContainerSlideIndex--;
			$(scrollContainerIdDiv).find('.horizontal-scroll').animate({
				scrollLeft: '-=' + scrollContainerWidth
			}, scrollSpeed);
		}
		localStorage.setItem("slideIndex_" + scrollContainerId, scrollContainerSlideIndex);
		nextArrow(scrollContainerId, scrollContainerSlideIndex);
		previousArrow(scrollContainerId, scrollContainerSlideIndex);
	}
	function nextArrow(scrollContainerId, slideIndex) {
		var scrollContainerSlideNumber = localStorage.getItem("slideNumber_" + scrollContainerId);
		var scrollContainerIdDiv = "#" + scrollContainerId;
		if (slideIndex >= scrollContainerSlideNumber) {
			$(scrollContainerIdDiv).find('.horizontal-arrow-right').attr('disabled', 'disabled');
			$(scrollContainerIdDiv).find('.horizontal-arrow-right').css('opacity', '0.3');
		}
		else {
			$(scrollContainerIdDiv).find('.horizontal-arrow-right').removeAttr('disabled');
			$(scrollContainerIdDiv).find('.horizontal-arrow-right').css('opacity', '1');
		}
	}
	function previousArrow(scrollContainerId, slideIndex) {
		var scrollContainerIdDiv = "#" + scrollContainerId;
		if (slideIndex <= 0) {
			$(scrollContainerIdDiv).find('.horizontal-arrow-left').attr('disabled', 'disabled');
			$(scrollContainerIdDiv).find('.horizontal-arrow-left').css('opacity', '0.3');
		}
		else {
			$(scrollContainerIdDiv).find('.horizontal-arrow-left').removeAttr('disabled');
			$(scrollContainerIdDiv).find('.horizontal-arrow-left').css('opacity', '1');
		}
	}
}


//Horaizontal Carousel
(function () {
    function loadDragIcon(componentId) {
        const container = document.querySelector(`#${componentId} .horizontal-scroll`);
        const dragIcon = document.querySelector(`#${componentId} .drag-icon`);
        if (!container || !dragIcon) return;

        dragIcon.style.display = 'none';

        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;

        container.addEventListener('mouseenter', () => {
            dragIcon.style.display = 'flex';
        });

        container.addEventListener('mouseleave', () => {
            dragIcon.style.display = 'none';
        });

        dragIcon.addEventListener('mouseenter', () => {
            dragIcon.style.display = 'flex';
        });

        container.addEventListener('mousemove', (event) => {
            const rect = container.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            dragIcon.style.left = `${x - 100}px`;
            dragIcon.style.top = `${y - 40}px`;

            if (isDragging) {
                const walk = x - startX;
                container.scrollLeft = scrollLeft - walk;
                updateArrowState(componentId);
            }
        });

        dragIcon.addEventListener('mousedown', (event) => {
            isDragging = true;
            event.preventDefault();
            const rect = container.getBoundingClientRect();
            startX = event.clientX - rect.left;
            scrollLeft = container.scrollLeft;
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
            updateArrowState(componentId);
        });
    }

    function horizontalImageSlider(id) {
        const container = $("#" + id).find('.horizontal-scroll');
        if (container.length > 0) {
            container[0].scrollLeft = 0;
            updateArrowState(id);
        }
    }

    function updateArrowState(id) {
        const container = document.querySelector(`#${id} .horizontal-scroll`);
        const leftArrow = document.querySelector(`#${id} .horizontal-arrow-left`);
        const rightArrow = document.querySelector(`#${id} .horizontal-arrow-right`);

        if (!container || !leftArrow || !rightArrow) return;

        const scrollLeft = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const tolerance = 1; 

        const atStart = scrollLeft <= tolerance;
        const atEnd = scrollLeft >= maxScrollLeft - tolerance;

        leftArrow.disabled = atStart;
        leftArrow.style.opacity = atStart ? '0.3' : '1';
        leftArrow.style.cursor = atStart ? 'auto' : 'pointer';
        leftArrow.classList.toggle('disable', atStart);
        leftArrow.classList.toggle('enabled', !atStart);

        rightArrow.disabled = atEnd;
        rightArrow.style.opacity = atEnd ? '0.3' : '1';
        rightArrow.style.cursor = atEnd ? 'auto' : 'pointer';
        rightArrow.classList.toggle('disable', atEnd);
        rightArrow.classList.toggle('enabled', !atEnd);
    }

    function rightScroll(id) {
        const container = document.querySelector(`#${id} .horizontal-scroll`);
        if (!container) return;

        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const currentScroll = container.scrollLeft;
        const scrollAmount = container.clientWidth;

        const remainingScroll = maxScrollLeft - currentScroll;
        const actualScroll = Math.min(scrollAmount, remainingScroll);

        container.scrollBy({ left: actualScroll, behavior: 'smooth' });

        setTimeout(() => updateArrowState(id), 500);
    }

    function leftScroll(id) {
        const container = document.querySelector(`#${id} .horizontal-scroll`);
        if (!container) return;

        const currentScroll = container.scrollLeft;
        const scrollAmount = container.clientWidth;

        const actualScroll = Math.min(scrollAmount, currentScroll);

        container.scrollBy({ left: -actualScroll, behavior: 'smooth' });

        setTimeout(() => updateArrowState(id), 500);
    }

    function initializeSlider(componentId) {
        horizontalImageSlider(componentId);

        setTimeout(() => {
            const scrollEl = document.querySelector(`#${componentId} .horizontal-scroll`);
            if (scrollEl) {
                scrollEl.style.setProperty('max-width', 'none', 'important');
            }
        }, 100);

        if (window.innerWidth > 1200) {
            loadDragIcon(componentId);
        }
        const scrollContainer = $(`#${componentId} .horizontal-scroll`);
        if (scrollContainer.length > 0) {
            scrollContainer.on('scroll', function () {
                updateArrowState(componentId);
            });
        }

        $(`#${componentId} .horizontal-arrow-left`).on('click', function () {
            leftScroll(componentId);
        });

        $(`#${componentId} .horizontal-arrow-right`).on('click', function () {
            rightScroll(componentId);
        });
    }

    // Initialize on load
    window.addEventListener('load', function () {
        initializeSlider('mediaCenter-News');
        initializeSlider('mediaCenter-Video');
        initializeSlider('Home-MorefromRMHC');
        initializeSlider('Home-MorefromRonald-McDonald-House');
        initializeSlider('horizontalIdDocument');
        initializeSlider('horizontalIdDocumentTwo');
    });

    // Re-initialize on resize
    window.addEventListener('resize', function () {
        initializeSlider('mediaCenter-News');
        initializeSlider('mediaCenter-Video');
        initializeSlider('Home-MorefromRMHC');
        initializeSlider('Home-MorefromRonald-McDonald-House');
        initializeSlider('horizontalIdDocument');
        initializeSlider('horizontalIdDocumentTwo');
    });


})();